import React from 'react';
import CardTemplateComponent from '../CardTemplate';
import { gtmSend } from '../../../helpers';
import { translate } from 'react-i18next';
import cx from '../../../styles';

const ArticleCard = ({title, inFeed, article, onArticleClick, message, viewUrl, match, botIndex, t}) => {

    let relValue = {};
    if(!botIndex){
        relValue = {
            rel: "nofollow"
        };
    }

	let titleHtml = "";
    if(title) {
        if(inFeed) {
            titleHtml = <p className={cx("page-title", "pointer-click")} onClick={() => {gtmSend('dynamic', 'Article Card', 'click-title-click', match.path)}}>
                            <a href={`/${viewUrl}`} {...relValue} dangerouslySetInnerHTML={{__html: title}}></a>
                        </p>
        }
        else {
            titleHtml = <h1 className={cx("page-title")} dangerouslySetInnerHTML={{__html: title}}></h1>
        }
    }

    let messageHtml = "";
    if(message) {
        if(!title && !inFeed) {
            messageHtml = <h1 className={cx('article-message')} dangerouslySetInnerHTML={{__html: message}}></h1>
        }
        else if(title && !inFeed) {
            messageHtml = <p dangerouslySetInnerHTML={inFeed ? {__html: message.replace(/^\s*[\r\n]/gm, '')} : {__html: message}}></p>
        }
        else{
            messageHtml = <p className={cx('article-message', inFeed && (message.length > 300 || message.split(/\r\n|\r|\n/).length > 3) ? "content-text-crop" : "")} onClick={() => {gtmSend('dynamic', 'Article Card', 'click-question-click', match.path)}}>
                            <a className={cx('article-message-link')} href={`/${viewUrl}`} {...relValue} dangerouslySetInnerHTML={inFeed ? {__html: message.replace(/^\s*[\r\n]/gm, '')} : {__html: message}}></a>
                          </p>
        }
    }

    return (
        <div className={cx("question-elements", "article-card")}>
        	{titleHtml}
            <div className={cx("text-desc")}>
                { messageHtml }
                
                { inFeed && message && (message.length > 300 || message.split(/\r\n|\r|\n/).length > 3) && <a className={cx('read-more-link')} href={`/${viewUrl}`}>{t('lp_read_more')}</a> }
            </div>
        	<section>
        		<div className={cx("link-share-card")}>
        			<a onClick={() => onArticleClick(article.url)} href={article.url} target="_blank" rel="noopener noreferrer">
                        <div className={cx("bg-img")}>
                            <img className={cx("bg-img")} src={article.thumbnail} alt="article-image" onError={e=>e.target.style.display = 'none'}/>
                        </div>
                        <span className={cx('article-title-desc')}>
                            <span className={cx('article-title')}>{article.title}</span>
    		                <span className={cx('article-desc')}>{article.description}</span>
                        </span>
		            </a>
        		</div>
        	</section>
        </div>
    );
}

const ArticleCardComponent = CardTemplateComponent(ArticleCard);

export default translate()(ArticleCardComponent);
